import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {metrics} from '~/vendor/metrics';
import {Button, Link, Stack} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function SizesUnavailableWarning(props) {
  useEffect(() => {
    const notification = props.notification || {};
    if (notification.droppedSizes) {
      const {droppedSizes, colorName} = notification;
      const hasOutOfStockDroppedSize = droppedSizes.some(
        droppedSize => droppedSize.status === 'inactive'
      );
      if (hasOutOfStockDroppedSize) {
        metrics.pageViewTag(
          `/ndx/quote/error/swap_oos/${colorName ? 'color' : 'style'}`
        );
      }
    }
  }, [props.notification]);

  const nbsp = String.fromCharCode(0x00a0);
  const notification = props.notification || {};
  const colorName = notification.colorName;
  const productName = notification.productName;
  const droppedSizes = notification.droppedSizes
    .map(drop => `${drop.quantity}${nbsp}${drop.size}`)
    .join(', ')
    .replace(/, ([^,]+)$/, ' and $1');
  const hideChooseAnotherItemCTA = notification.hideChooseAnotherItemCTA;

  return (
    <Notification {...props} title="Some sizes are unavailable">
      <p className="ndx-cta1">
        If you switch to the
        {colorName && !productName ? ' color ' : ' '}
        <strong>
          {productName}
          {productName && colorName && ' in '}
          {colorName}
        </strong>
        , the following sizes will be dropped:
        <strong> {droppedSizes}</strong>
      </p>
      <Stack className="notification-stack">
        <Button
          className="notification-cta"
          size="large"
          variant="secondary"
          onClick={() => props.confirm(true)}>
          Continue
        </Button>
        {!hideChooseAnotherItemCTA && (
          <p className="ndx-cta1">
            or{' '}
            <Link href="#/productCatalog" onClick={props.dismiss}>
              choose another item
            </Link>
            .
          </p>
        )}
      </Stack>
    </Notification>
  );
}

const propTypes = {
  confirm: PropTypes.func,
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    colorName: PropTypes.string,
    droppedSizes: PropTypes.array,
    hideChooseAnotherItemCTA: PropTypes.bool,
    productName: PropTypes.string
  })
};

SizesUnavailableWarning.propTypes = propTypes;

SizesUnavailableWarning.displayName = 'SizesUnavailableWarning';

import {bindActionCreators} from 'redux';
import {confirm} from '~/actions/NotificationActions';

function actions(dispatch) {
  return bindActionCreators(
    {
      confirm
    },
    dispatch
  );
}

import {connect} from 'react-redux';

export default connect(null, actions)(SizesUnavailableWarning);
